/**
 * This file is part of the box.co.il project.

 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */
;(function($) {
  window.isInvalidZipCode = function(zip) {
    if (!/^\d{7}$/.test(zip)) {
      return false;
    }

    if (/^(\d)\1{6}$/.test(zip)) {
      return true;
    }

    var ascending = true;
    var descending = true;
    var i;
    var current;
    var previous;

    for (i = 1; i < zip.length; i++) {
      current = parseInt(zip.charAt(i), 10);
      previous = parseInt(zip.charAt(i - 1), 10);

      if (current !== previous + 1) {
        ascending = false;
      }
      if (current !== previous - 1) {
        descending = false;
      }
    }

    return ascending || descending;
  };

  // Zip / company number rules by address country. Keep in sync with
  // appendZipValidationErrors() / appendCompanyIdValidationErrors() in app/helpers/functions.php.
  window.isIsraelCountry = function(country) {
    return 'IL' === $.trim(country || '').toUpperCase();
  };

  // IL: 7 digits (not a 1111111 / 1234567 sequence); other countries: English letters, digits, space and hyphen, up to 10.
  window.isValidZipForCountry = function(zip, country) {
    zip = $.trim(zip || '');

    if (window.isIsraelCountry(country)) {
      return /^\d{7}$/.test(zip) && !window.isInvalidZipCode(zip);
    }

    return /^[A-Za-z0-9][A-Za-z0-9 \-]{0,9}$/.test(zip);
  };

  // IL: 9 digits starting with 5; other countries: 2-30 English letters, digits, space, hyphen, dot and slash.
  window.isValidCompanyIdForCountry = function(companyId, country) {
    companyId = $.trim(companyId || '');

    if (window.isIsraelCountry(country)) {
      return /^5\d{8}$/.test(companyId);
    }

    return /^[A-Za-z0-9][A-Za-z0-9 .\/\-]{1,29}$/.test(companyId);
  };

  window.isInvalidOptionalPhone = function(phone) {
    phone = $.trim(phone);

    if (phone === '') {
      return false;
    }

    if (!/^[\d\s+\-().]+$/.test(phone)) {
      return true;
    }

    var digits = phone.replace(/\D/g, '');

    return digits.length < 9 || digits.length > 15;
  };

  /**
   * Get list of validation rules with messages.
   *
   * @returns {{}}
   */
  jQuery.fn.getValidationRulesList = function () {

    var rules = $(this).data('validation-rules');
    
    return typeof rules === typeof undefined || rules === false ? {} : rules;
  };

  /**
   * Get list of validation rules with messages.
   *
   * @returns {{}}
   */
  jQuery.fn.hasValidationRule = function (rule) {

    var rules = $(this).getValidationRulesList();

    return rule in rules;
  };

  /**
   * Add status to validated form field
   *
   * @param {String} status
   */
  jQuery.fn.validationSetStatus = function(status) {
    var container = $(this).closest('.validation');

    // add indicator if not exists
    if(false == container.hasClass('validation-no-indicate') && 0 == container.find('.validation-state').length) {
      container.append('<span class="validation-state">');
    }

    // remove all statuses
    if('none' == status) {
      container.removeClass('validation-valid validation-not-valid');
    }

    // valid
    if('valid' == status) {
      container.removeClass('validation-not-valid');
      container.addClass('validation-valid');
    }

    // not valid
    if('not-valid' == status) {
      container.removeClass('validation-valid');
      container.addClass('validation-not-valid');
    }
  };

  /**
   * Remove validation errors
   */
  jQuery.fn.validatorClearErrors = function() {
    var el = $(this);

    el.find('.alert-danger').remove();
    el.find('.has-error').removeClass('has-error');
  };
  
  /**
   * This extensions provide default validation.
   * Creates tooltips for validation errors.
   *
   * todo@alexbuturlakin: refactoring - create jquery plugin for validate2 package
   * 
   * @param {{}} rules
   * @param {String|function} [container]
   * @param [errorHandler]
   */
  jQuery.fn.validatorEnableDefaultValidation = function (rules, container, errorHandler) {
    var form  = $(this);
    
    // validation callback for form
    var callbackForm  = function (status, errors, groups) {
      var errorsList = {},
          errorContainer;

      if('function' == typeof container) {
        errorContainer = container(status, errors, groups);
      } else {
        errorContainer = $(container);
        errorContainer = 0 == container.length ? form : container;
      }
      
      // clear container
      errorContainer.validatorClearErrors();

      // all is ok
      if(status) {
        return true;
      }
      
      // get all errors
      $.each(errors, function(name, values) {
        var el          = form.find('[name="{0}"]'.format(name)),
            label       = el.data('error-label'),
            elContainer = el.closest('.form-group');

        elContainer.addClass('has-error');

        if(null == label) {
          label = elContainer.find('label')
              .clone()    //clone the element
              .children(':not(span)') //select all the children
              .remove()   //remove all the children
              .end()      //again go back to selected element
              .text().trim();
        }

        if(typeof undefined == typeof label || null == label) {
          label = null;
        } else {
          label = '<span class="error-field">{0}</span>'.format(label);
        }

        errorsList[name] = {
          error: values[0]['message'],
          label: label,
          rule:  values[0]['rule']
        };
      });

      // call callback
      if('function' == typeof errorHandler) {
        errorsList = errorHandler(errorsList);
      }

      // show errors in container
      if($.isPlainObject(errorsList)) {
        var message = $.map(errorsList, function(data) {
          return null == data['label'] ? data['error'] : '{0}: {1}'.format(data['label'], data['error']);
        }).join('<br>');

        errorContainer.showAlert(message, 'danger', null, 'append', null, false);
      }
    };

    // init validator
    var validator = new FormValidator(form.attr('name'), [], {
      callbacks: {form: [callbackForm]}
    });

    // add rules to FormValidator
    $.each(rules, function(name, data) {
      var el = form.find('[name="{0}"]'.format(name));
      var dataRules = {};
      var messages = 'messages' in data ? data.messages : {};

      // add validation handler
      validator._addField(data, name);

      // save rules in el data
      var rulesArr = data.rules.split('|');

      for (var k in rulesArr) {
        var info = validator._getRuleInfo(rulesArr[k]);

        // if message was overridden
        if (0 !== Object.keys(messages).length && info.method in messages) {
          // ping about it validator
          validator.setMessage(name + '.' + info.method, messages[info.method]);
          dataRules[info.method] = messages[info.method];
        } else {
          dataRules[info.method] = validator._getMessage(name, info.method, info.params);
        }
      }

      // set default status
      if(undefined !== el.val() && null !== el.val() && '' != el.val()) {
        el.addClass('has-predefined-value');

        // set status
        el.validationSetStatus('valid')
      }

      // add rules to data
      el.data('validation-rules', dataRules);
    });

    form.data('validator', validator);
  };  

  /**
   * This extensions provide to validate forms fields and show errors in qtip2 tooltips.
   * Creates tooltips for validation errors.
   *
   * todo@alexbuturlakin: refactoring - create jquery plugin for validate2 package
   *
   * @param rules
   */
  jQuery.fn.validatorEnableTooltipValidation = function (rules) {
    // validation callback for form
    var callbackForm  = function (status, errors) {
      var form = $(this);

      if(true == status) {
        return true;
      }

      // get elements with errors
      var selectors = [];

      $.each(errors, function(name, values) {
        selectors.push('[name="{0}"]'.format(name));
      });

      var inputs   = form.find(selectors.join(','));
      var controls = inputs.closest('.validation');

      // highlight
      controls.addClass('validation-not-valid');
      inputs.addClass('highlight');

      setTimeout(function(){
        inputs.removeClass('highlight');
      }, 2000);

      // focus to first error
      var inputFirst = inputs.eq(0);
      inputFirst.scrollToElement(500, -60, function() {
        inputFirst.focus();

        // if select2
        if(inputFirst.hasClass('select2')) {
          inputFirst.select2("open");
        }
      });
    };

    // validation callback for fields
    var callbackFields  = function (status, type, field, errors) {
      var el      = $(this);
      var tooltip = el.qtip().tooltip;

      // =)
      if('form' == type) {
        return true;
      }

      if(status) {
        // disable tooltip
        el.qtip('hide');
        el.qtip('disable');

        // set status
        el.validationSetStatus('valid')
      } else {
        // enable tooltip
        el.qtip('disable', false);
        el.qtip('show');

        // hide error messages in tooltip
        
        // get selectors
        var liSelectors = ['[data-rule="rule-default"]'];
        for(var k in errors) {
          var rule = errors[k]['rule'];
          
          liSelectors.push('[data-rule="{0}"]'.format(rule));
        }

        // hide not actual errors and show actual
        if(tooltip && 0 !== tooltip.length) {
          var notActual = tooltip.find('li:not({0})'.format(liSelectors.join(',')));
          var actual    = tooltip.find(liSelectors.join(','));

          notActual.hide(500);
          actual.show(500);
        }

        // set status
        '' == el.val() ? el.validationSetStatus('none') : el.validationSetStatus('not-valid');
      }
    };

    var form      = $(this);
    var validator = new FormValidator(form.attr('name'), [], {
      callbacks: {fields: [callbackFields], form: [callbackForm]}
    });

    // add rules to FormValidator
    $.each(rules, function(name, data) {
      var el        = form.find('[name="{0}"]'.format(name));
      var dataRules = {};
      var messages  = 'messages' in data ? data.messages : {};
      
      // add validation handler
      validator._addField(data, name);

      // save rules in el data
      var rulesArr = data.rules.split('|');

      for(var k in rulesArr) {
        var info = validator._getRuleInfo(rulesArr[k]);

        // if message was overridden
        if(0 !== Object.keys(messages).length && info.method in messages) {
          // ping about it validator
          validator.setMessage(name+'.'+info.method, messages[info.method]);
          dataRules[info.method] = messages[info.method];
        } else {
          dataRules[info.method] = validator._getMessage(name, info.method, info.params);
        }
      }

      // set default status
      if(undefined !== el.val() && null !== el.val() && '' != el.val()) {
        el.addClass('has-predefined-value');
      
        // set status
        el.validationSetStatus('valid')
      }

      el.data('validation-rules', dataRules);

      // form validation on key up
      // text inputs integration
      el.keyup(function() {
        validator.validateField(name);
        validator.cleanErrors();

        // fast fix for password and password confirm
        if(el.hasValidationRule('password')) {
          var el2 = el.closest('form').find('[name="password2"]');

          if(el2.val() == el.val() && '' != el.val()) {
            el2.validationSetStatus('valid');
          } else {
            el2.validationSetStatus('not-valid');
          }
        }
      });

      // checkboxes integration
      if('checkbox' == el.attr('type')) {
        el.on('change', function() {
          validator.validateField(name);
          validator.cleanErrors();
        });
      }

      // select boxes integration
      if(undefined != el.prop('tagName') && 'select' == el.prop('tagName').toLowerCase()) {
        el.on('change', function() {
          validator.validateField(name);
          validator.cleanErrors();
        });
      }
    });

    form.data('validator', validator);
  };

  /**
   * Validate form.
   *
   * @param {[]} [groups]
   * 
   * @returns {boolean}
   */
  jQuery.fn.validateForm = function(groups) {
    groups = groups || [];
    
    var form      = $(this),
        validator = form.getValidator();

    // if not a form
    if(false == validator) {
      return false;
    }
    
    // validate
    return validator._validateForm(groups);
  };

  /**
   * Get form validator.
   * 
   * @returns FormValidator
   */
  jQuery.fn.getValidator = function() {
    var form      = $(this),
        validator = $(this).data('validator');

    // if not a form
    if('form' != form.prop('tagName').toLowerCase()) {
      return false;
    }

    // form don't have validator
    if(null == validator || 'object' !== typeof validator) {
      return false;
    }
    
    return validator;
  };

  /**
   * Disable or enable validation for form.
   * 
   * @param {Boolean} state
   * @param {String} [group]
   * @returns {boolean}
   */
  jQuery.fn.disableValidation = function(state, group) {
    var form      = $(this),
        validator = form.getValidator();

    // if not a form
    if(false == validator) {
      return false;
    }

    state ? validator.disable(group) : validator.enable();
  };

  /**
   * Change validator field rules
   *
   * @param {String} name
   * @param {String} rules
   * @param {{}}     [messages]
   *
   * @returns {boolean}
   */
  jQuery.fn.validatorChangeFieldRules = function (name, rules, messages) {
    var form      = $(this),
        validator = form.getValidator();

    // if not a form
    if(false == validator) {
      return false;
    }

    validator.changeFiledRules(name, rules, messages);
  };

  /**
   * Register custom rule.
   * 
   * @param {String}   name
   * @param {function} callback
   * @param {String}   [message]
   * 
   * @returns {boolean}
   */
  jQuery.fn.validatorAddRule = function(name, callback, message) {
    var form      = $(this),
        validator = form.getValidator();

    // if not a form
    if(false == validator) {
      return false;
    }

    validator.registerCallback(name, callback);
  };

  /**
   * Box form submissions
   */
  jQuery.fn.validateSubmit = function() {
    var form   = $(this);
    var submit = form.find('button[type="submit"]');

    // add data loading
    submit.buttonLoading('loading');

    $.post(form.getFormSubmitPath(), form.serialize(), function (data) {

      if(data.status) {
        window.location.href = data.page;
      } else {
        form.showAlert(nl2br(data.msg, true), 'danger', null, 'prepend').scrollToElement(500, -60);
      }

      submit.buttonLoading('reset');
    });
  };

  /**
   * Concat form values
   *
   * @param {[]} elements
   * @param {String} [sep]
   *
   * @returns {string}
   */
  jQuery.fn.concatFormValues = function(elements, sep) {
    sep = sep || '';
    var res = '';

    for(var k in elements) {
      var el  = elements[k];
      var val = el instanceof jQuery ? el.val().trim() : $(this).find(el).val().trim();

      res += sep + val;
    }

    return res.trim();
  };

  /**
   * Returns actual fields for phone number.
   *
   * @returns {string[]}
   */
  jQuery.fn.getTelFields = function() {
    var tel2 = $(this).find('.tel-2');

    // fast fix for compatibility on different pages
    return tel2.closest('.form-control-inner').hasClass('hidden') || tel2.hasClass('hidden') ?
        [
          '.tel-3',
          '.tel-4',
          '.tel-1'
        ] :
        [
          '.tel-3',
          '.tel-2',
          '.tel-1'
        ];
  };

})(jQuery);